import React, { useMemo } from 'react';
import { useAuth } from '../contexts/AuthProvider';
import { useNavigation } from '../contexts/NavigationProvider';
import UsersIcon from './icons/UsersIcon';
import type { User } from '../types';

const ProfileManagerPage: React.FC = () => {
    const { currentUser, users, startManaging } = useAuth();
    const { handleNavigation } = useNavigation();

    const manageableProfiles = useMemo(() => {
        if (!currentUser) return [];
        return users.filter(user => user.collaborators?.includes(currentUser.handle));
    }, [currentUser, users]);

    const handleManageClick = (profile: User) => {
        startManaging(profile);
        handleNavigation('feed');
    };

    return (
        <div className="space-y-6">
            <div className="bg-brand-surface rounded-lg p-6">
                <div className="flex items-center space-x-3">
                    <UsersIcon className="h-7 w-7 text-brand-orange" />
                    <h2 className="text-3xl font-bold text-white">Manage Profiles</h2>
                </div>
                <p className="mt-2 text-brand-muted">
                    You have collaborator access to the following profiles. Select one to manage their content.
                </p>
            </div>
            
            <div className="bg-brand-surface rounded-lg p-6">
                {manageableProfiles.length > 0 ? (
                    <ul className="space-y-4">
                        {manageableProfiles.map(profile => (
                            <li key={profile.handle} className="bg-gray-800/50 p-4 rounded-lg flex justify-between items-center">
                                <div className="flex items-center space-x-4">
                                    <img src={profile.avatarUrl} alt={profile.name} className="h-12 w-12 rounded-full" />
                                    <div>
                                        <h3 className="font-bold text-lg text-white">{profile.name}</h3>
                                        <p className="text-sm text-brand-muted">@{profile.handle}</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => handleManageClick(profile)}
                                    className="bg-brand-orange text-white font-bold px-4 py-2 rounded-full text-sm hover:opacity-90"
                                >
                                    Manage
                                </button>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-center text-brand-muted py-8">
                        You are not a collaborator on any profiles yet.
                    </p>
                )}
            </div>
        </div>
    );
};

export default ProfileManagerPage;